'use client';

import { useTranslations } from 'next-intl';

import { BlogPageType, urlMap } from '@/fo/feature/article/page/blog';
import { UiArticleCarouselBase } from '@/fo/ui/article/carousel/base';
import { ArticleItem } from '@/fo/ui/article/list/base';

import { styles } from './RelatedPosts.styles';

export interface RelatedPostsProps {
  posts: ArticleItem[];
  type: BlogPageType;
}

const postTypesMap = {
  [BlogPageType.Article]: 'article',
  [BlogPageType.News]: 'news',
  [BlogPageType.Video]: 'video'
} as const;

export function RelatedPosts({ posts, type }: RelatedPostsProps) {
  const slots = styles();

  const t = useTranslations();

  const postType = t(
    `article.page.post.postTypes.${postTypesMap[type]}`
  ).toLowerCase();

  return (
    <UiArticleCarouselBase
      className={slots.base()}
      articles={posts}
      title={t('article.page.post.relatedPostsTitle', {
        postType
      })}
      buttonText={t('article.page.post.allPosts', {
        postType
      })}
      buttonLink={`/about-skin/${urlMap[type]}`}
    />
  );
}
